
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Actions from '../../../components/docs/Actions';
import Home from '../../../components/docs/Home';
import Guide from 'plaid-threads/Icons/Guide';
import AlertBell from 'plaid-threads/Icons/AlertBell';
import Libraries from 'plaid-threads/Icons/Libraries';
export const metadata = {
  toc: false,
  section: 'Exchange',
  title: 'Welcome',
  description: "Plaid Exchange Documentation Portal."
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Callout = makeShortcode("Callout");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header title='Welcome' subtitle={metadata.description} mdxType="Header"></Header>
    <h2 {...{
      "id": "introduction"
    }}>{`Introduction`}</h2>
    <Callout warning mdxType="Callout">
      <p>{`This API specification is intended for reference purposes only. New data partners should not use this guide to build their integration.
Please refer to our latest API specification, Core Exchange, for the most up-to-date and supported integration approach compatible with the FDX standard.
For more information, visit the `}<a parentName="p" {...{
          "href": "https://plaid.com/core-exchange/docs/"
        }}>{`Core Exchange docs`}</a>{`. If you already have a Plaid Exchange integration, see the `}<a parentName="p" {...{
          "href": "/core-exchange/docs/migrating-from-plaid-exchange"
        }}>{`migration guide`}</a>{` for how to move it to Core Exchange.`}</p>
    </Callout>
    <p>{`The Plaid Exchange API specification facilitates building of the following endpoints:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`/oauth2/auth`}</inlineCode>{`: OAuth 2.0 Auth flow`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`/oauth2/token`}</inlineCode>{`: OAuth 2.0 Token flow`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`/users/{user_id}`}</inlineCode>{`: Retrieve account and identity information`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`/users/{user_id}/transactions`}</inlineCode>{`: Retrieve transaction history`}</li>
    </ul>
    <h2 {...{
      "id": "data-connectivity-benefits"
    }}>{`Data connectivity benefits`}</h2>
    <h3 {...{
      "id": "plaid-network"
    }}>{`Plaid network`}</h3>
    <p>{`Once your Plaid Exchange API has successfully been validated by Plaid, your organization will appear in the list of available apps in Plaid Link. See the `}<a parentName="p" {...{
        "href": "https://plaid.com/demo/"
      }}>{`Plaid Link Demo`}</a>{` for a visual walkthrough of an end-user's experience.`}</p>
    <h3 {...{
      "id": "security-flow"
    }}>{`Security flow`}</h3>
    <p>{`Plaid uses your OAuth 2.0 flow to allow your users to connect their financial accounts to their other financial applications. Industry standards such as mTLS and PKCE are also supported in the current version.`}</p>
    <h2 {...{
      "id": "prospective-customer-support"
    }}>{`Prospective customer support`}</h2>
    <p>{`If you have a question about Plaid Exchange capabilities that isn't answered in the docs, `}<a parentName="p" {...{
        "href": "https://plaid.com/data-connectivity-core-exchange/#contactForm"
      }}>{`contact the Plaid Exchange sales team`}</a>{` to learn more.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "introduction",
        level: 2,
        title: "Introduction",
      },
{
        id: "data-connectivity-benefits",
        level: 2,
        title: "Data connectivity benefits",
      },
{
        id: "plaid-network",
        level: 3,
        title: "Plaid network",
      },
{
        id: "security-flow",
        level: 3,
        title: "Security flow",
      },
{
        id: "prospective-customer-support",
        level: 2,
        title: "Prospective customer support",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
